export class CompraCursoDto {
    materiaId: number;
    clave: string;
    nombre: string;
    costoCurso: number;
    imagenMateria: string;
}
